import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const BulkPrice = forwardRef<SVGSVGElement, SvgIconProps>(
  function BulkPrice(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <g fill="#D8D8D8">
          <path
            d="M19.42 10.258 9.741.581C9.419.194 8.903 0 8.387 0H1.936A1.9 1.9 0 0 0 0 1.936v6.45c0 .517.194 1.033.58 1.356l9.678 9.677c.387.387.904.581 1.355.581.451 0 .968-.194 1.355-.58l6.451-6.452c.775-.71.775-2 0-2.71zM4.515 5.807c-.71 0-1.291-.581-1.291-1.291s.58-1.291 1.29-1.291c.71 0 1.292.58 1.292 1.29 0 .71-.581 1.292-1.291 1.292z"
            transform="translate(3, 2)"
          />
        </g>
      </SvgIcon>
    )
  },
)

export default BulkPrice
